import React from "react";

import "./InlinePreloader.css";

const inlinePreloader = () => <div className="inline-preloader"></div>;

export default inlinePreloader;
